import api from "./Api";

class PlanoContasService {

    async listar(id: number): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`v2/PlanoConta/${id}`);
        return result;
    }
}


export default new PlanoContasService();